import {Component, OnDestroy, OnInit} from '@angular/core';
import {IDialogComponent} from "../../../../dialog/iDialog.component";
import {DialogWithInput} from "../../../../dialog/dialogWithInput";
import {CommonModule} from "@angular/common";
import {FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {DialogModule} from "../../../../dialog/dialog.module";
import {CardModule} from "../../../../../core/component/card/card.module";
import {FormFieldModule} from "../../../../../core/component/form-field/form-field.module";
import {InputTextModule} from "../../../../../core/component/input-text/input-text.module";
import {InputColorModule} from "../../../../../core/component/input-color/input-color.module";
import {
  CreateUpdateDefaultModule
} from "../../../../../core/component/create-update-default/create-update-default.module";
import {TagFindOneService} from "../../service/tagFindOne.service";
import {TagModel} from "../../model/tag.model";
import {TagSavePayload, TagSaveService} from "../../service/tagSave.service";
import {CustomDatePayload} from "../../../../custom-date/entity/payload/custom-date.payload";
import {ButtonModule} from "../../../../../core/component/button/button.module";
import {LoadingModule} from "../../../../../../components/common/loading/loading.module";

export interface TagSaveDialogInput {
  // Edit
  id?: number;

  // Creation
  entityTypeValue?: string;
}

export interface TagSaveDialogOutput {
  tag: TagModel;
}

@Component({
  selector: 'app-tag-save-dialog',
  templateUrl: './tag-save-dialog.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    CardModule,
    FormFieldModule,
    InputTextModule,
    InputColorModule,
    CreateUpdateDefaultModule,
    ButtonModule,
    LoadingModule,
  ],
  providers: [
    TagFindOneService,
    TagSaveService
  ]
})
export class TagSaveDialogComponent implements IDialogComponent<TagSaveDialogInput, TagSaveDialogOutput>,
    OnInit, OnDestroy {
  dialog: DialogWithInput<TagSaveDialogInput, TagSaveDialogOutput>;
  formGroup: FormGroup;

  constructor(private formBuilder: FormBuilder,
              public findOneService: TagFindOneService,
              public saveService : TagSaveService) {
    this.formGroup = this.formBuilder.group({
      summary: this.formBuilder.group({
        id: this.formBuilder.control(undefined),
      }),
      name: new FormControl(undefined, [Validators.required]),
      color: new FormControl(undefined, [Validators.required]),
      entityTypeValue: new FormControl(undefined, [Validators.required])
    })
  }

  ngOnInit() {
    if (this.dialog.input.entityTypeValue) {
      this.formGroup.patchValue({
        entityTypeValue: this.dialog.input.entityTypeValue,
      })
    }
  }

  ngOnDestroy() {
  }

  entityLoaded(entity: TagModel) {
    this.formGroup.patchValue({
      summary: {
        id: entity.summary.id
      },
      name: entity.summary.name,
      color: entity.summary.color,
      entityTypeValue: entity.entityType.value
    })
  }

  entitySaved(entity: TagModel) {
    this.dialog.close({
      tag: entity
    })
  }

  buildPayload(): TagSavePayload {
    return this.formGroup.value;
  }
}
